import React, {useEffect, useState,useRef,useContext,SyntheticEvent} from 'react';
import PropTypes from 'prop-types';

import {
    View,
    Text,
    StyleSheet,
    Dimensions,
    Platform,
    Modal,
    TouchableOpacity,
    TextInput,
    Pressable,
  } from 'react-native';
  import validator from 'validator';
 

   
 
   export default function Login(props:any) {
     const [username, setUserName] = useState();
     const [modalVisible, setModalVisible] = useState(true);
     const [hide, setHide]=useState(false);
     const [email, setEmail]=useState("");
     const [password, setPassword]=useState("");
     const [dim, setDim] = useState([
        Dimensions.get('window').width,
        Dimensions.get('window').height,
        Dimensions.get('window').width > Dimensions.get('window').height,
      ]);
      const isDesktop = dim[0] > 1224;
      const isSmall = dim[0] < 540;
   
      const submitForm= (e:any)=>{
        e.preventDefault();
          if(email ==="" || password =="" ){
            alert("Email or Password cannot be empty");
          }
          else{
            //console.log("email:", email,password);
            //props.setToken({"token":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyLCJleHAiOjE3MDEyMDI1Nzl9.9OnY3QPwR2y8GslwAYUOX7Z3KbNN0XgwGEzY-UaqFPY"});
            if (validator.isEmail(email)) {
                //console.log('Valid Email :');
                fetch('https://ip-test.teleport.umms.org/login', {
                    method: 'POST',
                    body: JSON.stringify({
                        username:email,
                        password:password
                    }),
                    headers: {
                      'Content-Type': 'application/json'
                    }
                  }).then(res => res.json()).then(data =>{
                   // console.log("result:", data);
                     if(data.result ==="OK"){
                        props.setToken({"token":data.token});
                     }
                     else{
                        alert('Wrong login or password');
                     }
                  });
               

              } else {
                alert('Enter a valid Tiger ID with @umm.edu!');
              }

          }
      };

      const handleKeypress = (e:any) => {
        if (e.keyCode === 13) {
          submitForm(e);
        }
      };
   
     return(
        <Modal
    animationType="fade"
    transparent={true}
    visible={true}
    
  >
     
   <View style={[styles.centeredView,{display:hide===true?'none':'flex'}]}>
   
      <View style={[styles.modalView, {borderRadius:20, width:isSmall ? "80%":"25%", height:isSmall ? '50%': '40%', marginTop:isSmall ? 0:50, justifyContent:'center'}]}>
        <Text style={{textDecorationLine: 'underline', color:'#ffffff', fontSize:isSmall ? 12:20, marginBottom:40}}> Sign In</Text>
        <Text style={{ color:'#ffffff', fontSize:isSmall ? 12:20, marginBottom:20, textAlign:'center'}}>
         Username</Text>
         <TextInput style={[styles.input,{textAlign:'center'}]} value={email} onChangeText={setEmail} placeholder='username@umm.edu'/>
         <Text style={{ color:'#ffffff', fontSize:isSmall ? 12:20, marginBottom:10, marginTop:10}}> Password</Text>
         <TextInput onKeyPress={handleKeypress} style={[styles.input,{textAlign:'center'}]}  value={password} secureTextEntry={true} onChangeText={setPassword}/>
       <Pressable   onPress={submitForm} style={{ alignItems:'center', justifyContent:'center', 
        backgroundColor:'#02beed', borderRadius:10, height:40, width:80,marginTop:20,borderColor:'#000000', borderWidth:2}}>
              <Text style={{textAlign:'center', color:'#000000',fontSize:14}}>Login </Text>
        </Pressable>

      
    </View>
    </View>
    
  </Modal>
     )
   }
   const styles = StyleSheet.create({
    input:{
     backgroundColor:'#fff',
     minHeight:30,
     minWidth:200,
     borderRadius:5,
     borderColor:'blue',
     padding:5,
     alignItems:'center',
    },
    counterBox:{
        borderColor:'#000000',
        borderWidth:2,
        position:'absolute', 
        alignItems:'center', 
        justifyContent:'center',
        backgroundColor:'#ef0505', 
        borderRadius:10, 
        height:150, 
        width:200,
        maxHeight:150, 
        maxWidth:200,
        marginTop:80,
        marginRight:20
      },
      xCloseButton:{
        position:'absolute',
        backgroundColor:'#ff0000', 
        alignSelf:'flex-start',
        height:40,
        width:40,
        maxHeight:40,
        maxWidth:40,
        padding:5,
        borderRadius:5,
     
      },
        xButtonContainer:{
            flex: 1,
            marginTop:20
        },
        xButton:{
            borderRadius: 10,
            padding: 10,
            fontWeight:'bold',
            color:'#ffffff'
        },
        centeredView: {
          flex: 1,
          justifyContent: "center",
          marginTop: 0,
          backgroundColor: "#cde0ff"+ 80 ,
        },
        modalView: {
         alignSelf:'center',
          backgroundColor: '#011a30',
          padding: 35,
          alignItems: "center",
        },
        button: {
          borderRadius: 10,
          padding: 10,
          elevation: 2,
          marginHorizontal:Platform.OS == "web" && Dimensions.get('screen').height>400 ? 10:0
        },
        buttonOpen: {
          backgroundColor: "#F194FF",
        },
        buttonYes:{
          backgroundColor: "#1aaa56",
        },
        buttonNo: {
          backgroundColor: "#ff0000",
        },
        buttonExit: {
            backgroundColor: "#2196F3",
          },
        textStyle: {
          color: "white",
          fontWeight: "bold",
          textAlign: "center"
        },
        modalText: {
          justifyContent:'center',
          marginTop:25,
          marginBottom: 50,
          textAlign: "center",
          fontSize:16,
          fontWeight: "bold",
        },
        modalContainer:{
            alignItems: 'center',
            justifyContent:'center',
           
        },
    
        buttonIconEnd: {
            width: 30,
            height: 25,
            // marginLeft: 3,
            //tintColor: '#f86051',
            //tintColor: $config.PRIMARY_COLOR,
            color:'#f86051',
            backgroundColor:'blue',
            
          },
});
   
   Login.propTypes = {
     setToken: PropTypes.func.isRequired
   };